import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";
import styled from "styled-components";

import GlobalContext from "../../context/GlobalContext";

const FooterStyled = styled.footer`
  background: var(--nd-black);
  border-top: 1px solid var(--nd-border);
  padding: 64px 0 32px;
`;

const FooterTitle = styled.h4`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin-bottom: 16px;
`;

const FooterText = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-disabled);
  line-height: 1.6;
  max-width: 280px;
  margin-bottom: 16px;
`;

const FooterLink = styled(Link)`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-disabled) !important;
  text-decoration: none;
  display: block;
  margin-bottom: 8px;
  transition: color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover {
    color: var(--nd-text-primary) !important;
  }
`;

const FooterExtLink = styled.a`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-disabled) !important;
  text-decoration: none;
  display: block;
  margin-bottom: 8px;
  transition: color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover {
    color: var(--nd-text-primary) !important;
  }
`;

const BookButton = styled.button`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid var(--nd-border-visible);
  background: transparent;
  color: var(--nd-text-primary);
  cursor: pointer;
  margin-top: 8px;
  transition: border-color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
  &:hover { border-color: var(--nd-text-primary); }
`;

const Copyright = styled.div`
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid var(--nd-border);
  text-align: center;
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
`;

const Footer = () => {
  const gContext = useContext(GlobalContext);

  return (
    <FooterStyled>
      <Container>
        <Row>
          <Col lg="3" md="6" className="mb-4">
            <FooterTitle>DIOSCURO</FooterTitle>
            <FooterText>
              Small DevOps team. 15 years of cloud infrastructure.
              Working US hours.
            </FooterText>
            <FooterExtLink
              href="https://www.linkedin.com/company/dioscuro-llc"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </FooterExtLink>
            <FooterExtLink
              href="https://github.com/fabiopalumbo"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </FooterExtLink>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <FooterTitle>PRODUCTS</FooterTitle>
            <FooterLink to="/pricing">Retainers &amp; Pricing</FooterLink>
            <FooterLink to="/staffing">Mentorship + Staffing</FooterLink>
            <FooterLink to="/academy">Academy</FooterLink>
            <FooterLink to="/how-we-work">How we work</FooterLink>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <FooterTitle>TOOLS</FooterTitle>
            <FooterLink to="/labs">Labs</FooterLink>
            <FooterLink to="/career-path">Career Path</FooterLink>
            <FooterLink to="/infrastructure">Infrastructure Dashboard</FooterLink>
            <FooterLink to="/examples">Examples</FooterLink>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <FooterTitle>CONTACT</FooterTitle>
            <FooterExtLink
              href="https://cal.com/fabio-dioscuro/intro"
              target="_blank"
              rel="noopener noreferrer"
            >
              cal.com/fabio-dioscuro/intro
            </FooterExtLink>
            <FooterExtLink href="mailto:hello@dioscuro.com">
              hello@dioscuro.com
            </FooterExtLink>
            <BookButton
              aria-label="Book a call"
              onClick={(e) => { e.preventDefault(); gContext.toggleContact(); }}
            >
              Book a call
            </BookButton>
          </Col>
        </Row>
        <Copyright>
          &copy; {new Date().getFullYear()} DIOSCURO. ALL RIGHTS RESERVED.
        </Copyright>
      </Container>
    </FooterStyled>
  );
};

export default Footer;
